import {useState} from "react"
import {apiShareRoom} from "./Api"

const INIT_STATE = {code: null, email: "", name: "", phone: "", roomName: "", consulting: false}

export const useShareSolution = (code = null, roomName = null, consulting = false) => {
    const [state, setStata] = useState({...INIT_STATE, code, roomName, consulting})

    const isValid = () => {
        return getEmail().trim().length > 0 && (isConsultation() ? (getName().trim() && getPhone().trim()) : true)
    }

    const submit = () => {
        return apiShareRoom(state)
    }

    const reset = () => {
        setEmail("")
    }

    const getCode = () => {
        return state.code
    }

    const setCode = (code) => {
        setStata(prevState => ({...prevState, code}))
    }

    const getEmail = () => {
        return state.email
    }

    const setEmail = (email) => {
        setStata(prevState => ({...prevState, email}))
    }

    const getName = () => {
        return state.name
    }

    const setName = (name) => {
        setStata(prevState => ({...prevState, name}))
    }

    const getPhone = () => {
        return state.phone
    }

    const setPhone = (phone) => {
        setStata(prevState => ({...prevState, phone}))
    }

    const getRoomName = () => {
        return state.roomName
    }

    const setRoomName = (roomName) => {
        setStata(prevState => ({...prevState, roomName}))
    }

    const isConsultation = () => {
        return state.consulting
    }

    const setConsultation = () => {
        setStata(prevState => ({...prevState, consulting: true}))
    }

    const toggleConsultation = () => {
        setStata(prevState => ({...prevState, consulting: !prevState.consulting}))
    }

    return {
        isValid, submit, reset,
        getCode, setCode,
        getEmail, setEmail,
        getName, setName,
        getPhone, setPhone,
        getRoomName, setRoomName,
        isConsultation, setConsultation, toggleConsultation
    }
}